import type { NodePropertyValue } from '../../../types/properties';

const defaults: Record<string, NodePropertyValue> = {
  sourceField: 'data',
  extractionMode: 'cssSelector',
  extractions: { values: [] },
  options: {
    trimWhitespace: true,
    convertEntities: true,
  },
};

export default defaults;
